(ns bec-cljs-common.components.icon
  (:require [reagent.core :as r]
            [bec-cljs-common.components.flag-icons :as flag-icon]))

(defn icon [& [props]]
  (let [size (or (:size props) (:size (:style props)))]
    (into
      [(if (:on-click props) :button.is-clickable.icon :span.icon)
       (merge
         (when (map? props) (dissoc props :size))
         {:style (merge
                   {:font-size size
                    :height size
                    :width size}
                   (dissoc (:style props) :size))})]
      (r/children (r/current-component)))))

(defn flag-class [& [props]]
  (flag-icon/main props))

(defn angle-down [& [props]]
  (let [active? (or (:active? props) (:is-active? props))]
    [icon
     (dissoc props :icon-class :is-active? :active?)
     [:i.fas.fa-angle-down
      {:class (or (:icon-class props) "fas fa-angle-down")
       :style {:transform (when active? "rotate(0)" "rotate(180deg)")
               :transition "transform var(--transition-duration) ease"}}]]))